import styled from "styled-components";

import { Modal, ModalProps } from "components/Modal";
import { useTranslation } from "react-i18next";

export const IncompleteGameModal: React.FC<ModalProps> = ({
  onClose,
  ...props
}) => {
  const { t } = useTranslation();
  
  return (
    <ModalWrapper {...props} onClose={onClose}>
      <Text>
        {t('You have an incomplete scratch card, we will return you to the game now.')}
      </Text>
      <Button onClick={onClose}>
        <span>{t('CLOSE')}</span>
      </Button>
    </ModalWrapper>
  );
};

const ModalWrapper = styled(Modal)`
  width: 250px;
  height: 270px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Text = styled.p`
  font-size: 20px;
  line-height: 19.5px;
  letter-spacing: 0.7px;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
  padding: 0 40px;
  margin: 30px 0;
`;

const Button = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  width: 160px;
  height: 40px;
  padding: 0;
  padding-top: 10px;
  margin: 0 auto;
  cursor: pointer;

  span {
    display: block;
    margin-top: -4px;
    position: relative;
    background-image: linear-gradient(
      to bottom,
      #000 51%,
      rgba(87, 84, 84, 0.82) 72%,
      #000 96%
    );
    font-family: Teko;
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  &::before {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 8px;
    box-shadow: 0 3px 10px 0 rgba(255, 155, 0, 0.55), 0 2px 0 0 #985b09,
      inset 0 3px 0 0 #fff;
    border: solid 1.5px #ffe893;
    background-image: linear-gradient(
      to bottom,
      #cf9b5e 0%,
      #fff8d3 51%,
      #cf9b5e 100%
    );
  }
`;
